<template>
  <button class="hidden" v-print="'#single-stone'" ref="single_stone_print"></button>
  <div class="hidden">
    <div id="single-stone" class="absolute top-0 left-0 p-0 m-0" v-if="print_data.id">
      <div v-if="page_data.base_url == 'https://santkrupa.kodllin.com/apis/public/'">
        <div class="flex items-center justify-between mt-1 px-2">
          <div class="flex items-center justify-start">
          <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;">{{ $h.myFloat(print_data.weight) }} &nbsp;</span>
          <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.mk_weight">({{ print_data.stock_type == 2 ? (print_data.pieces  + ' | ') : '' }} {{ $h.myFloat(print_data.mk_weight) }}) &nbsp;</span>
          <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.polish_weight">({{ $h.myFloat(print_data.polish_weight) }})</span>
        </div>
          <div class="flex items-center justify-end">
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.purity">{{ print_data.purity }}</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.purity && print_data.shape">&nbsp;/&nbsp;</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.color">{{ print_data.color }}</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.color && print_data.shape">&nbsp;/&nbsp;</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="print_data.shape">{{ print_data.shape }}</span>
          </div>
        </div>
        <div class="flex items-center justify-center w-full">
          <div><VueBarcode class="py-0 my-0" :value="print_data.barnum" :options="{ displayValue: false,height:22,width:1.8 }" tag="svg"></VueBarcode></div>
        </div>
        <div class="flex items-center justify-between px-1 w-full">
          <div><span class="m-auto" style="font-size: 12px ;font-weight: 900;line-height: 15px;" v-if="print_data.vepari_no">{{ print_data.vepari_no }}</span></div>
          <div><p class="text-right p-0 mt-1 text-black" style="font-size: 7px;line-height: 1;letter-spacing: 2px;font-weight: bold;">KODLLIN <br> TECHONOLOGY</p></div>
        </div>


      </div>
      <div v-else>
        <table class="p-0 m-0 w-full text-black" border="collapse">
            <tr class="text-center m-0 p-0">
                <td colspan="2" class="text-center" style="font-size: 12px;line-height: 1;letter-spacing: 3px;">GEM PROWESS</td>
            </tr>
            <tr class="text-center m-0 p-0">
              <th colspan="2" class="text-center">
                <VueBarcode :value="print_data.barnum" :options="{ displayValue: false,height:22,width:1.5 }" tag="svg"></VueBarcode>
              </th>
            </tr>
            <tr class="text-center m-0 p-0">
                <th class="text-left m-0 p-0" style="font-size: 12px;line-height: 12px;">{{ print_data.vepari_no }}</th>
                <th class="text-right m-0 p-0" style="font-size: 12px;line-height: 12px;">{{ print_data.weight }}</th>
            </tr>
            <tr class="text-left m-0 p-0">
                <td class="pt-1" style="font-size: 12px;line-height: 12px;">{{ print_data.date }}</td>
                <!-- <th style="font-size: 12px;line-height: 12px;">{{ print_data.weight }}</th> -->
            </tr>
        </table>
      </div>
    </div>
  </div>
  <button class="hidden" v-print="'#multi-stone'" ref="multi_stone_print"></button>
  <div class="hidden">
    <div id="multi-stone" class="absolute top-0 left-0 p-0 m-0">
      <div style="page-break-before: always;" v-for="(item,index) in print_arr_data" :key="index">
        <div class="mt-2" v-if="page_data.base_url == 'https://santkrupa.kodllin.com/apis/public/' && item.id">
          <div class="flex items-center justify-between mt-1 px-2">
            <div class="flex items-center justify-start">
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;">{{ $h.myFloat(item.weight) }} &nbsp;</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.mk_weight">({{ item.stock_type == 2 ? (item.pieces  + ' | ') : '' }} {{ $h.myFloat(item.mk_weight) }}) &nbsp;</span>
            <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.polish_weight">({{ $h.myFloat(item.polish_weight) }})</span>
          </div>
            <div class="flex items-center justify-end">
              <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.purity">{{ item.purity }}</span>
              <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.purity && item.shape">&nbsp;/&nbsp;</span>
              <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.color">{{ item.color }}</span>
              <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.color && item.shape">&nbsp;/&nbsp;</span>
              <span class="m-auto" style="font-size: 10px; font-weight: 900;line-height: 10px;" v-if="item.shape">{{ item.shape }}</span>
            </div>
          </div>
          <div class="flex items-center justify-center w-full">
            <div><VueBarcode class="py-0 my-0" :value="item.barnum" :options="{ displayValue: false,height:22,width:1.5 }" tag="svg"></VueBarcode></div>
          </div>
          <div class="flex items-center justify-between px-1 w-full">
            <div><span class="m-auto" style="font-size: 12px ;font-weight: 900;line-height: 15px;" v-if="item.vepari_no">{{ item.vepari_no }}</span></div>
            <div><p class="text-right p-0 mt-1 text-black" style="font-size: 7px;line-height: 1;letter-spacing: 2px;font-weight: bold;">KODLLIN <br> TECHONOLOGY</p></div>
          </div>

        </div>
        <div v-else>
          <table class="p-0 m-0 w-full text-black" border="collapse">
            <tr class="text-center m-0 p-0">
                <td colspan="2" class="text-center" style="font-size: 12px;line-height: 1;letter-spacing: 3px;">GEM PROWESS</td>
            </tr>
            <tr class="text-center m-0 p-0">
              <th colspan="2" class="text-center">
                <VueBarcode :value="item.barnum" :options="{ displayValue: false,height:22,width:1.5 }" tag="svg"></VueBarcode>
              </th>
            </tr>
            <tr class="text-center m-0 p-0">
                <th class="text-left m-0 p-0" style="font-size: 12px;line-height: 12px;">{{ item.vepari_no }}</th>
                <th class="text-right m-0 p-0" style="font-size: 12px;line-height: 12px;">{{ item.weight }}</th>
            </tr>
            <tr class="text-left m-0 p-0">
                <td class="pt-1" style="font-size: 12px;line-height: 12px;">{{ item.date }}</td>
                <!-- <th style="font-size: 12px;line-height: 12px;">{{ item.weight }}</th> -->
            </tr>
        </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
 import { BASE_URL } from '@/constants/config.js'
import { reactive, ref } from 'vue';
import moment from 'moment';

const page_data = reactive({
  base_url: BASE_URL,
});

const single_stone_print = ref();
const multi_stone_print = ref();

const print_data = reactive({
    id: "",
    vepari_no: "",
    number: "",
    type: "",
    mk_weight: "",
    weight: "",
    polish_weight: "",
    barnum: "",
    shape: "",
    color: "",
    purity: "",
    cut: "",
    polish: "",
    symmetry: "",
    fluerocent: "",
    tension: "",
    stone: "",
    length: "",
    width: "",
    height: "",
    date: "",
  })

const print_arr_data = ref([]);

const setPrintData = (data) => {
  print_data.id = data.id
  print_data.vepari_no = (data.vepari_no ?? "");
  print_data.number = (data.number ?? "");
  print_data.mk_weight = (data.mk_weight ?? "");
  print_data.weight = (data.weight ?? "");
  print_data.polish_weight = (data.polish_weight ?? "");
  print_data.type = (data.type ?? "");
  print_data.stock_type = (data.stock_type ?? "");
  print_data.barnum = (data.barnum ?? "");
  print_data.shape = (data.shape ?? "");
  print_data.color = (data.color ?? "");
  print_data.purity = (data.purity ?? "");
  print_data.cut = (data.cut ?? "");
  print_data.polish = (data.polish ?? "");
  print_data.symmetry = (data.symmetry ?? "");
  print_data.fluerocent = (data.fluerocent ?? "");
  print_data.tension = (data.tension ?? "");
  print_data.stone = (data.stone ?? "");
  print_data.length = (data.length ?? "");
  print_data.width = (data.width ?? "");
  print_data.height = (data.height ?? "");
  print_data.date = (data.date ? moment(data.date).format("DD-MM-YYYY") : "");

  setTimeout(() => {
    single_stone_print.value.click();
  }, 100);
}
const setPrintAllData = (data) => {

  console.log('dataCallaed')

  print_arr_data.value = data

  print_arr_data.value.forEach(element => {
    element.date = (element.date ? moment(element.date).format("DD-MM-YYYY") : "");
  });
  setTimeout(() => {
    multi_stone_print.value.click();
  }, 100);
}

defineExpose({
  setPrintData,
  setPrintAllData
})
</script>
